import * as i0 from '@angular/core';
import { Injectable, Component, Inject, ViewEncapsulation, Input, ViewChild, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i9 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as moment from 'moment';
import * as Roles from 'app-models';
import { License, acceptedFileTypes } from 'app-models';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { environment } from 'environment-configurations';
import * as errorUtils from 'error-message-utility';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import { sync_profile_code } from 'permission-library';
import * as i1$1 from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as i2 from '@ngrx/store';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2$1 from 'ngx-toastr';
import * as i5 from '@angular/router';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i10 from '@angular/material/expansion';
import { MatExpansionModule } from '@angular/material/expansion';
import * as i11 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i12 from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import * as i13 from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i14 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i15 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i16 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i17 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i18 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i19 from 'file-upload-deafult-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import * as i20 from 'file-download-library';
import { FileDownloadLibraryModule } from 'file-download-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SaveAsDraftModule } from 'save-as-draft';
import { PrimengLibraryModule } from 'primeng-library';

class EditLicenseDetailsService {
    constructor(http) {
        this.http = http;
        this.uploaded$ = new BehaviorSubject({});
        this.deletedfile$ = new BehaviorSubject({});
        this.showBeneficiary = new BehaviorSubject(false);
    }
    getBeneDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId) {
        return this.http.get(`/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=true`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    saveTrainingDetails(payload) {
        let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        return this.http.post(`/petition/saveTrainingOrLicense/${petitionId}/LICENSE`, payload).pipe(map((response) => response));
    }
    getTrainingsDetails(beneficiaryId, type, familyId) {
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/beneficiary/${beneficiaryId}/profile/professional/${type}${profileFamilyString}`).pipe(map((response) => response.data));
    }
    deleteLicenceDocuments(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    // IM-3066 - remove deleted file.
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    uploaded() {
        this.uploaded$.next(true);
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
}
EditLicenseDetailsService.ɵfac = function EditLicenseDetailsService_Factory(t) { return new (t || EditLicenseDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
EditLicenseDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: EditLicenseDetailsService, factory: EditLicenseDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditLicenseDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ConfirmationModalComponent {
    constructor(dialogRef, dialogData, store) {
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.store = store;
        this.buttons = [];
        this.dialogRef.disableClose = true;
    }
    ngOnInit() {
        this.title = this.dialogData.update.title;
        this.message = this.dialogData.update.message;
        this.buttons = (this.dialogData.buttons) ? this.dialogData.buttons : ['No', 'Yes'];
    }
    onConfirm() {
        // Close the dialog, return true
        this.dialogRef.close(true);
        this.store.dispatch(new MarkCleanFormAction({
            dirty: false
        }));
    }
    onDismiss() {
        // Close the dialog, return false
        this.dialogRef.close(false);
    }
    handleNo() {
        this.dialogRef.close(false);
    }
}
ConfirmationModalComponent.ɵfac = function ConfirmationModalComponent_Factory(t) { return new (t || ConfirmationModalComponent)(i0.ɵɵdirectiveInject(i1$1.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i2.Store)); };
ConfirmationModalComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmationModalComponent, selectors: [["app-confirmation-modal"]], decls: 14, vars: 4, consts: [["mat-dialog-title", ""], [1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["mat-dialog-content", "", 1, "message"], ["mat-dialog-actions", "", 1, "float-right"], ["mat-raised-button", "", "color", "primary", 1, "btnCustom", "mr-3", 3, "click"], ["mat-button", "", 1, "btnCustom", 3, "click"]], template: function ConfirmationModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "h5", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "i", 4);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_i_click_5_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "button", 7);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_10_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ConfirmationModalComponent_Template_button_click_12_listener() { return ctx.onDismiss(); });
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.buttons[1]);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.buttons[0]);
    } }, styles: ["h5[_ngcontent-%COMP%]{color:#475f7b}.message[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:18px}button[_ngcontent-%COMP%]:last-child{margin-left:5px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#553b7c;padding:10px;border-radius:20px;cursor:pointer;font-size:10px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:0 0 15px!important}.btnCustom[_ngcontent-%COMP%]{color:#fff;background:#2196f3;border:1px solid #2196f3;padding:.5rem 1rem;font-size:1rem;transition:background-color .2s,color .2s,border-color .2s,box-shadow .2s}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmationModalComponent, [{
        type: Component,
        args: [{
                selector: 'app-confirmation-modal',
                templateUrl: './confirmation-modal.component.html',
                styleUrls: ['./confirmation-modal.component.scss']
            }]
    }], function () { return [{ type: i1$1.MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i2.Store }]; }, null); })();

function EditLicenseDetailsComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelementStart(1, "button", 9);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.toggleListView(false); });
    i0.ɵɵelementStart(2, "mat-icon", 10);
    i0.ɵɵtext(3, "timeline");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " Timeline View ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 11);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_3_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.toggleListView(true); });
    i0.ɵɵelementStart(6, "mat-icon", 12);
    i0.ɵɵtext(7, "list");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8, " List View ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("activebtn", ctx_r1.isTimeLineView);
    i0.ɵɵadvance(4);
    i0.ɵɵclassProp("activebtn", ctx_r1.isListView);
} }
function EditLicenseDetailsComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
} }
function EditLicenseDetailsComponent_div_0_div_5_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_5_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(3); return ctx_r9.toggleListView(true); });
    i0.ɵɵelementStart(1, "mat-icon", 17);
    i0.ɵɵtext(2, "add_circle_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_5_button_1_Template, 3, 0, "button", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r3.viewMode);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 84);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r38); i0.ɵɵnextContext(); const _r18 = i0.ɵɵreference(7); const _r20 = i0.ɵɵreference(11); const ctx_r37 = i0.ɵɵnextContext(3); ctx_r37.toggleExpansion(); _r18.reset(); return ctx_r37.formCheck(_r20); });
    i0.ɵɵtext(1, "Add License / Certificate");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Licenses Or Certifications");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_span_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 85);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.getGlobalErrorMessages("INVALID_DATE"), " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_37_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 85);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.getGlobalErrorMessages("INVALID_DATE"), " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_37_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelementStart(1, "label", 38);
    i0.ɵɵtext(2, "End Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-form-field", 46);
    i0.ɵɵelementStart(4, "input", 86, 87);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_37_Template_input_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(4); return ctx_r42.license.endDate = $event; })("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_37_Template_input_click_4_listener() { i0.ɵɵrestoreView(_r43); const _r40 = i0.ɵɵreference(8); return _r40.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mat-datepicker-toggle", 49);
    i0.ɵɵelement(7, "mat-datepicker", null, 88);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_37_span_9_Template, 2, 1, "span", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r39 = i0.ɵɵreference(5);
    const _r40 = i0.ɵɵreference(8);
    const ctx_r26 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r26.license.endDate)("min", ctx_r26.license.startDate)("matDatepicker", _r40);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r40);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", _r39.touched && _r39.errors && !_r39.errors.required);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_47_Template(rf, ctx) { if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelementStart(1, "button", 89);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_47_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r46); i0.ɵɵnextContext(); const _r20 = i0.ɵɵreference(11); const ctx_r45 = i0.ɵɵnextContext(3); return ctx_r45.closeForm(_r20); });
    i0.ɵɵtext(2, "Close");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_51_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Topics or Subjects Covered");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_67_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 92);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_67_Template(rf, ctx) { if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 90);
    i0.ɵɵlistener("removed", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_67_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r50); const subject_r47 = ctx.$implicit; const ctx_r49 = i0.ɵɵnextContext(4); return ctx_r49.remove(subject_r47); });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_67_mat_icon_2_Template, 2, 0, "mat-icon", 91);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subject_r47 = ctx.$implicit;
    const ctx_r30 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("selectable", ctx_r30.selectable)("removable", ctx_r30.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", subject_r47, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r30.removable);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 96);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r51 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r51.header, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 99);
    i0.ɵɵelementStart(1, "mat-icon", 100);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_1_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r61); const i_r56 = i0.ɵɵnextContext().index; const ctx_r59 = i0.ɵɵnextContext(5); return ctx_r59.deleteSubject(i_r56); });
    i0.ɵɵtext(2, "delete_forever ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r55 = i0.ɵɵnextContext().$implicit;
    const column_r51 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r55[column_r51.columnDef], " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 97);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_1_Template, 3, 0, "span", 98);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_span_2_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r51 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r51.columnType == "icon");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r51.columnType == "text");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 93);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_th_1_Template, 2, 1, "th", 94);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_td_2_Template, 3, 2, "td", 95);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r51 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r51.columnDef);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_77_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 101);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_78_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 102);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_87_Template(rf, ctx) { if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 103);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_87_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r67); i0.ɵɵnextContext(); const _r20 = i0.ɵɵreference(11); const _r18 = i0.ɵɵreference(7); const ctx_r66 = i0.ɵɵnextContext(3); ctx_r66.closeForm(_r20); return _r18.reset(); });
    i0.ɵɵtext(1, "Close");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_91_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Upload Documents");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_101_Template(rf, ctx) { if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 103);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_101_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r69); i0.ɵɵnextContext(); const _r20 = i0.ɵɵreference(11); const _r18 = i0.ɵɵreference(7); const ctx_r68 = i0.ɵɵnextContext(3); ctx_r68.closeForm(_r20); return _r18.reset(); });
    i0.ɵɵtext(1, "Close");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { disabledView: a0 }; };
function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_2_Template, 2, 0, "button", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-accordion");
    i0.ɵɵelementStart(4, "mat-expansion-panel", 29);
    i0.ɵɵelementStart(5, "mat-card");
    i0.ɵɵelementStart(6, "mat-horizontal-stepper", 30, 31);
    i0.ɵɵelementStart(8, "mat-step", 32);
    i0.ɵɵtemplate(9, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_9_Template, 1, 0, "ng-template", 33);
    i0.ɵɵelementStart(10, "form", 34, 35);
    i0.ɵɵlistener("ngSubmit", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_form_ngSubmit_10_listener() { i0.ɵɵrestoreView(_r71); const _r20 = i0.ɵɵreference(11); const ctx_r70 = i0.ɵɵnextContext(3); return _r20.form.valid && ctx_r70.saveLicenseTrianing(_r20); });
    i0.ɵɵelementStart(12, "div", 36);
    i0.ɵɵelementStart(13, "div", 37);
    i0.ɵɵelementStart(14, "label", 38);
    i0.ɵɵtext(15, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "input", 39, 40);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_16_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r72 = i0.ɵɵnextContext(3); return ctx_r72.license.name = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 41);
    i0.ɵɵelementStart(19, "label", 38);
    i0.ɵɵtext(20, "Issuing Organization");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "input", 42, 43);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_21_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r73 = i0.ɵɵnextContext(3); return ctx_r73.license.institution = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 41);
    i0.ɵɵelementStart(24, "mat-checkbox", 44);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_mat_checkbox_ngModelChange_24_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r74 = i0.ɵɵnextContext(3); return ctx_r74.infiniteDtFlag = $event; });
    i0.ɵɵtext(25, "This credentials does not expire ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 13);
    i0.ɵɵelementStart(27, "div", 45);
    i0.ɵɵelementStart(28, "label", 38);
    i0.ɵɵtext(29, "Start Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "mat-form-field", 46);
    i0.ɵɵelementStart(31, "input", 47, 48);
    i0.ɵɵlistener("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_31_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r75 = i0.ɵɵnextContext(3); return ctx_r75.license.startDate = $event; })("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_click_31_listener() { i0.ɵɵrestoreView(_r71); const _r24 = i0.ɵɵreference(35); return _r24.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "mat-datepicker-toggle", 49);
    i0.ɵɵelement(34, "mat-datepicker", null, 50);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(36, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_span_36_Template, 2, 1, "span", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(37, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_37_Template, 10, 5, "div", 52);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(38, "div", 53);
    i0.ɵɵelementStart(39, "div", 45);
    i0.ɵɵelementStart(40, "button", 54);
    i0.ɵɵtext(41, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(42, "hr");
    i0.ɵɵelementStart(43, "div", 55);
    i0.ɵɵelementStart(44, "div", 56);
    i0.ɵɵelementStart(45, "button", 57);
    i0.ɵɵtext(46, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(47, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_div_47_Template, 3, 0, "div", 58);
    i0.ɵɵelementStart(48, "div", 59);
    i0.ɵɵtext(49, "(Click on save button to save data)");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "mat-step");
    i0.ɵɵtemplate(51, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_51_Template, 1, 0, "ng-template", 33);
    i0.ɵɵelementStart(52, "div", 60);
    i0.ɵɵelementStart(53, "div", 37);
    i0.ɵɵelementStart(54, "div", 13);
    i0.ɵɵelementStart(55, "label", 13);
    i0.ɵɵtext(56, "Add topics or subjects covered in the Licenses or Certifications");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(57, "small");
    i0.ɵɵtext(58, "Enter all relevant Topics or Subjects Covered as a part of your Certifications using a comma to separate.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(59, "div", 61);
    i0.ɵɵelementStart(60, "div", 62);
    i0.ɵɵelementStart(61, "label", 63);
    i0.ɵɵtext(62, "Topics Or Subjects Covered");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(63, "div", 64);
    i0.ɵɵelementStart(64, "mat-form-field", 65);
    i0.ɵɵelementStart(65, "mat-chip-list", 66, 67);
    i0.ɵɵtemplate(67, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_mat_chip_67_Template, 3, 4, "mat-chip", 68);
    i0.ɵɵelementStart(68, "input", 69);
    i0.ɵɵlistener("paste", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_paste_68_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r77 = i0.ɵɵnextContext(3); return ctx_r77.pasteChips($event); })("ngModelChange", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_ngModelChange_68_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r78 = i0.ɵɵnextContext(3); return ctx_r78.topic = $event; })("input", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_input_68_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r79 = i0.ɵɵnextContext(3); return ctx_r79.onNewTopicEnter($event); })("matChipInputTokenEnd", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_input_matChipInputTokenEnd_68_listener($event) { i0.ɵɵrestoreView(_r71); const ctx_r80 = i0.ɵɵnextContext(3); return ctx_r80.add($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(69, "mat-hint", 70);
    i0.ɵɵtext(70, "Please enter comma separated values");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(71, "div", 71);
    i0.ɵɵelementStart(72, "button", 72);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_button_click_72_listener() { i0.ɵɵrestoreView(_r71); const ctx_r81 = i0.ɵɵnextContext(3); return ctx_r81.addSubjects(); });
    i0.ɵɵtext(73, "Add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(74, "div", 18);
    i0.ɵɵelementStart(75, "table", 73);
    i0.ɵɵtemplate(76, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_container_76_Template, 3, 1, "ng-container", 21);
    i0.ɵɵtemplate(77, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_77_Template, 1, 0, "tr", 25);
    i0.ɵɵtemplate(78, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_tr_78_Template, 1, 0, "tr", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(79, "div", 75);
    i0.ɵɵelement(80, "hr");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(81, "div", 61);
    i0.ɵɵelementStart(82, "div", 13);
    i0.ɵɵelementStart(83, "div", 76);
    i0.ɵɵelementStart(84, "button", 77);
    i0.ɵɵtext(85, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(86, "div", 78);
    i0.ɵɵtemplate(87, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_87_Template, 2, 0, "button", 79);
    i0.ɵɵelementStart(88, "button", 80);
    i0.ɵɵtext(89, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "mat-step");
    i0.ɵɵtemplate(91, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_ng_template_91_Template, 1, 0, "ng-template", 33);
    i0.ɵɵelementStart(92, "div", 60);
    i0.ɵɵelementStart(93, "div", 81);
    i0.ɵɵelementStart(94, "file-upload-deafult-library", 82);
    i0.ɵɵlistener("fileUploadSuccess", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_file_upload_deafult_library_fileUploadSuccess_94_listener() { i0.ɵɵrestoreView(_r71); const ctx_r82 = i0.ɵɵnextContext(3); return ctx_r82.fileUploadSuccess(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(95, "div", 61);
    i0.ɵɵelementStart(96, "div", 13);
    i0.ɵɵelementStart(97, "div", 76);
    i0.ɵɵelementStart(98, "button", 77);
    i0.ɵɵtext(99, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(100, "div", 78);
    i0.ɵɵtemplate(101, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_button_101_Template, 2, 0, "button", 79);
    i0.ɵɵelementStart(102, "button", 83);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template_button_click_102_listener() { i0.ɵɵrestoreView(_r71); const _r20 = i0.ɵɵreference(11); const _r18 = i0.ɵɵreference(7); const ctx_r83 = i0.ɵɵnextContext(3); ctx_r83.resetForm(_r20); return _r18.reset(); });
    i0.ɵɵtext(103, "Add Next Licenses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r20 = i0.ɵɵreference(11);
    const _r23 = i0.ɵɵreference(32);
    const _r24 = i0.ɵɵreference(35);
    const _r29 = i0.ɵɵreference(66);
    const ctx_r11 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r11.updateBenProfile && !ctx_r11.viewMode && ctx_r11.showEditButton);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("expanded", ctx_r11.expandPanel);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("linear", ctx_r11.isLinear);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("completed", ctx_r11.hasID);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(32, _c0, ctx_r11.isViewMode));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngModel", ctx_r11.license.name);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngModel", ctx_r11.license.institution);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r11.infiniteDtFlag);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r11.license.startDate)("max", ctx_r11.today)("matDatepicker", _r24);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r24);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", _r23.touched && _r23.errors && !_r23.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.infiniteDtFlag === false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", _r20.invalid);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", _r20.invalid && !ctx_r11.hasID);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r11.modeVal);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(34, _c0, ctx_r11.isViewMode));
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", ctx_r11.listAddedSubjects);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matChipInputFor", _r29)("matChipInputSeparatorKeyCodes", ctx_r11.separatorKeysCodes)("ngModel", ctx_r11.topic);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r11.listAddedSubjects.length === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("dataSource", ctx_r11.listSubjects);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.subjectsColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r11.subDisplayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r11.subDisplayedColumns);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", !ctx_r11.modeVal);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c0, ctx_r11.isViewMode));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("primaryData", ctx_r11.inputData)("configurations", ctx_r11.configurations);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", !ctx_r11.modeVal);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 105);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r84.header, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 107);
    i0.ɵɵelementStart(1, "a");
    i0.ɵɵelementStart(2, "mat-icon", 108);
    i0.ɵɵtext(3, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r98 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 111);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_mat_icon_1_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r98); const row_r88 = i0.ɵɵnextContext(4).$implicit; const ctx_r96 = i0.ɵɵnextContext(4); ctx_r96.handleEdit(row_r88); return ctx_r96.formCheck(ctx_r96.licForm); });
    i0.ɵɵtext(1, "edit ");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    const _r101 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 100);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_mat_icon_2_Template_mat_icon_click_0_listener() { i0.ɵɵrestoreView(_r101); const row_r88 = i0.ɵɵnextContext(4).$implicit; const ctx_r99 = i0.ɵɵnextContext(4); return ctx_r99.handleDelete(row_r88, ctx_r99.licForm); });
    i0.ɵɵtext(1, " delete_forever ");
    i0.ɵɵelementEnd();
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_mat_icon_1_Template, 2, 0, "mat-icon", 109);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_mat_icon_2_Template, 2, 0, "mat-icon", 110);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r93 = i0.ɵɵnextContext(7);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r93.viewMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r93.viewMode);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_ng_container_1_Template, 3, 2, "ng-container", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r92 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r92.isExternalEmployeeId);
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_span_1_Template, 2, 1, "span", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r84 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r84.columnDef == "action");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r88 = i0.ɵɵnextContext().$implicit;
    const column_r84 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r88[column_r84.columnDef], " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 97);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_span_1_Template, 4, 0, "span", 106);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_div_2_Template, 2, 1, "div", 7);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_span_3_Template, 2, 1, "span", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r84 = i0.ɵɵnextContext().$implicit;
    const ctx_r86 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r84.columnDef == "toggle");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r86.updateBenProfile && ctx_r86.showEditButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r84.columnType == "text");
} }
function EditLicenseDetailsComponent_div_0_div_6_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 93);
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_th_1_Template, 2, 1, "th", 104);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_td_2_Template, 4, 3, "td", 95);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r84 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", column_r84.columnDef);
} }
function EditLicenseDetailsComponent_div_0_div_6_td_12_div_2_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 118);
    i0.ɵɵelementStart(1, "td", 119);
    i0.ɵɵelementStart(2, "div", 120);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 121);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sub_r111 = ctx.$implicit;
    const i_r112 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i_r112 + 1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", sub_r111, " ");
} }
function EditLicenseDetailsComponent_div_0_div_6_td_12_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 115);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Topics");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 116);
    i0.ɵɵtemplate(5, EditLicenseDetailsComponent_div_0_div_6_td_12_div_2_tr_5_Template, 6, 2, "tr", 117);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r106 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r106.subjects);
} }
function EditLicenseDetailsComponent_div_0_div_6_td_12_div_3_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 119);
    i0.ɵɵelementStart(2, "div", 120);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "strong");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 121);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 121);
    i0.ɵɵelement(10, "file-download-library", 125);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r115 = ctx.$implicit;
    const i_r116 = ctx.index;
    const ctx_r114 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i_r116 + 1, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r115.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (item_r115 == null ? null : item_r115.fileCategory == null ? null : item_r115.fileCategory.code) === "OTHER" ? item_r115 == null ? null : item_r115.fileCategoryOtherName : item_r115 == null ? null : item_r115.fileCategory == null ? null : item_r115.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("fileName", item_r115.fileLocation.substring(23))("Path", ctx_r114.envPath + item_r115.fileLocation.substring(23));
} }
function EditLicenseDetailsComponent_div_0_div_6_td_12_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 115);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 122);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 119);
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Document");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵelement(13, "i", 123);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, EditLicenseDetailsComponent_div_0_div_6_td_12_div_3_tr_15_Template, 11, 5, "tr", 124);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r106 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", element_r106.documents);
} }
function EditLicenseDetailsComponent_div_0_div_6_td_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 112);
    i0.ɵɵelementStart(1, "div", 113);
    i0.ɵɵtemplate(2, EditLicenseDetailsComponent_div_0_div_6_td_12_div_2_Template, 6, 1, "div", 114);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_6_td_12_div_3_Template, 16, 1, "div", 114);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r106 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("colspan", ctx_r13.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r106 == ctx_r13.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r106 == null ? null : element_r106.subjects == null ? null : element_r106.subjects.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (element_r106 == null ? null : element_r106.documents == null ? null : element_r106.documents.length) > 0);
} }
function EditLicenseDetailsComponent_div_0_div_6_tr_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 101);
} }
function EditLicenseDetailsComponent_div_0_div_6_tr_14_Template(rf, ctx) { if (rf & 1) {
    const _r120 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 126);
    i0.ɵɵlistener("click", function EditLicenseDetailsComponent_div_0_div_6_tr_14_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r120); const element_r118 = ctx.$implicit; const ctx_r119 = i0.ɵɵnextContext(3); return ctx_r119.expandedElement = ctx_r119.expandedElement === element_r118 ? null : element_r118; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r118 = ctx.$implicit;
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("example-expanded-row", ctx_r15.expandedElement === element_r118);
} }
function EditLicenseDetailsComponent_div_0_div_6_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 127);
} }
const _c1 = function () { return ["expandedDetail"]; };
function EditLicenseDetailsComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, EditLicenseDetailsComponent_div_0_div_6_ng_container_1_Template, 104, 38, "ng-container", 7);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵelementStart(3, "div", 19);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "table", 20);
    i0.ɵɵtemplate(7, EditLicenseDetailsComponent_div_0_div_6_ng_container_7_Template, 3, 1, "ng-container", 21);
    i0.ɵɵelementStart(8, "div", 22);
    i0.ɵɵelementContainerStart(9, 23);
    i0.ɵɵelementStart(10, "label");
    i0.ɵɵtext(11, " List of Topics ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, EditLicenseDetailsComponent_div_0_div_6_td_12_Template, 4, 4, "td", 24);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, EditLicenseDetailsComponent_div_0_div_6_tr_13_Template, 1, 0, "tr", 25);
    i0.ɵɵtemplate(14, EditLicenseDetailsComponent_div_0_div_6_tr_14_Template, 1, 2, "tr", 26);
    i0.ɵɵtemplate(15, EditLicenseDetailsComponent_div_0_div_6_tr_15_Template, 1, 0, "tr", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r4.isExternalEmployeeId);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", ctx_r4.dataSource && ctx_r4.dataSource.data.length > 0 ? ctx_r4.dataSource.data.length : "No", " Licenses Added by you");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", ctx_r4.dataSource);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.columns);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r4.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r4.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(7, _c1));
} }
function EditLicenseDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelement(2, "div", 3);
    i0.ɵɵtemplate(3, EditLicenseDetailsComponent_div_0_div_3_Template, 9, 4, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EditLicenseDetailsComponent_div_0_div_4_Template, 1, 0, "div", 5);
    i0.ɵɵtemplate(5, EditLicenseDetailsComponent_div_0_div_5_Template, 2, 1, "div", 6);
    i0.ɵɵtemplate(6, EditLicenseDetailsComponent_div_0_div_6_Template, 16, 8, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r0.modeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isTimeLineView && (ctx_r0.licenseData == null ? null : ctx_r0.licenseData.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isTimeLineView && (ctx_r0.licenseData == null ? null : ctx_r0.licenseData.length) == 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isListView);
} }
class EditLicenseDetailsComponent {
    constructor(apiService, toastr, dialog, store, route) {
        this.apiService = apiService;
        this.toastr = toastr;
        this.dialog = dialog;
        this.store = store;
        this.route = route;
        this.iscaseRequest = false;
        this.currentItemDisplay = [];
        this.modeVal = false;
        this.showEditButton = true;
        this.expandPanel = false;
        this.updateBenProfile = true;
        this.selectedIndex = 0;
        this.license = new License({});
        this.categoryName = 'BENLICDOC';
        this.listUploadedFiles = [];
        this.infiniteDtFlag = false;
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.hasID = false;
        this.isLinear = true;
        this.today = new Date();
        this.separatorKeysCodes = [ENTER, COMMA];
        this.listAddedSubjects = [];
        this.viewMode = false;
        this.configurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENLICDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENLICDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            isDeleteEnabled: this.viewMode ? false : true,
            isUploadEnabled: this.viewMode ? false : true,
            familyId: null
        };
        this.displayedColumns = [];
        this.subDisplayedColumns = [];
        this.subjectsColumns = [
            { columnDef: 'subject', header: 'Added Topics', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.columns = [
            { columnDef: 'toggle', header: '', columnType: 'icon', customClass: '' },
            { columnDef: 'name', header: 'Name', columnType: 'text', customClass: '' },
            { columnDef: 'institution', header: 'Organization', columnType: 'text', customClass: '' },
            { columnDef: 'startDate', header: 'Start Date', columnType: 'text', customClass: '' },
            { columnDef: 'endDate', header: 'End Date', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        this.isListView = false;
        this.isTimeLineView = true;
        this.licenseData = [];
        this.destroy$ = new Subject();
        this.formChangesSubscriptions = [];
        this.observableSubscription$ = new Subject();
        this.isSaveAsDraftDisabled = true;
        this.isLocked = false;
        this.isExternalEmployeeId = sessionStorage.getItem('_isExternalEmployeeId');
        if (this.isExternalEmployeeId) {
            this.isLocked = true;
        }
    }
    ngOnInit() {
        this.showLifeStoryTimeLineSection = true;
        this.modeVal = true;
        this.beneficiaryType = 'self';
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.viewMode = false;
        if (sessionStorage.getItem('userTypeRole') === Roles.ATTORNEY || sessionStorage.getItem('userTypeRole') === Roles.PETITIONER) {
            const permission = JSON.parse(sessionStorage.getItem('currentUser'));
            permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
            this.updateBenProfile = permission;
            this.viewMode = !this.updateBenProfile;
        }
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        this.beneficiaryId = JSON.parse(sessionStorage.getItem('beneficiaryId'));
        // this.getLicense();
        this.envPath = environment.docs;
        // IM-3066 - remove deleted file.
        this.apiService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            if (status === true) {
                this.getLicense();
            }
        });
        this.apiService.uploaded$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            if (status === true) {
                this.getLicense();
            }
        });
    }
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
        this.subDisplayedColumns = this.subjectsColumns.map(c => c.columnDef);
    }
    formCheck(licForm) {
        var _a;
        this.licForm = licForm;
        this.formChangesSubscriptions[0] = licForm.statusChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(() => {
            if (licForm.dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
        this.formChangesSubscriptions[1] = (_a = this.licForm.valueChanges) === null || _a === void 0 ? void 0 : _a.pipe(takeUntil(this.observableSubscription$)).subscribe(formValues => {
            this.isSaveAsDraftDisabled = !Object.values(formValues).some((val) => !!val || val === 0);
        });
    }
    onNewTopicEnter(event) {
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
    }
    toggleExpansion() {
        this.expandPanel = !this.expandPanel;
        this.hasID = false;
        this.isLinear = true;
        this.infiniteDtFlag = false;
        this.license = {
            id: 0,
            name: '',
            subjects: '',
            institution: '',
            startDate: '',
            endDate: ''
        };
        this.listUploadedFiles = [];
        this.configurations.listUploadedFiles = [];
        this.configurations.entityId = 0;
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.configurations = Object.assign({}, this.configurations);
        this.listSubjects = new MatTableDataSource();
    }
    getLicense() {
        this.apiService.getBeneDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response === null || response === void 0 ? void 0 : response['data']) {
                response['data'].map((item) => {
                    if (item.subjects) {
                        item.subjects = item.subjects.split(',');
                    }
                });
                response['data'].map((item) => {
                    item.startDate = item.startDate ? moment(item.startDate).format('DD-MMM-YYYY') : '';
                    item.endDate = item.endDate ? moment(item.endDate).format('DD-MMM-YYYY') : '';
                });
                this.licenseData = response['data'];
                this.dataSource = new MatTableDataSource(response['data']);
            }
        });
    }
    handleEdit(input) {
        if (this.expandPanel !== true) {
            this.expandPanel = true;
            if (input && input.endDate === '') {
                this.infiniteDtFlag = true;
            }
            this.license = {
                id: input.id,
                name: input.name,
                subjects: input.subjects,
                institution: input.institution,
                startDate: input.startDate ? moment(input.startDate).toISOString() : '',
                endDate: (input.endDate) ? moment(input.endDate).toISOString() : ''
            };
            const obj = [];
            if (input.subjects) {
                input.subjects.forEach((item) => {
                    obj.push({ 'subject': item });
                });
            }
            this.hasID = true;
            this.isLinear = false;
            this.listSubjects = new MatTableDataSource(obj);
            this.license.subjects = input.subjects && input.subjects.length ? input.subjects.join() : [];
            this.configurations.entityId = input.id;
            this.configurations.useCaseId = this.beneficiaryId;
            this.configurations.familyId = this.familyId ? this.familyId : null;
            this.listUploadedFiles = input.documents ? this.listUploadedFiles.concat(input.documents) : [];
            this.configurations.listUploadedFiles = input.documents ? this.configurations.listUploadedFiles.concat(input.documents) : [];
            this.configurations = Object.assign({}, this.configurations);
        }
    }
    handleDelete(input, licForm) {
        const title = 'Confirm';
        const message = 'Do you wish to remove this item?';
        this.dialogueInitializer(event, title, message).afterClosed().subscribe(result => {
            if (result) {
                this.apiService.deleteLicenceDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_LICENSE, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                    if (response.status === 200) {
                        if (this.license.id === input.id) {
                            this.resetForm(licForm);
                        }
                        this.toastr.success(response.message, 'Success');
                        this.getLicense();
                    }
                });
            }
        });
    }
    saveLicenseTrianing(licForm, isDraft = false) {
        const payload = {
            id: this.license.id || 0,
            name: this.license.name,
            subjects: this.license.subjects,
            institution: this.license.institution,
            startDate: this.license.startDate ? moment(this.license.startDate).format('YYYY-MM-DD') : null,
            endDate: (this.license.endDate) ? moment(this.license.endDate).format('YYYY-MM-DD') : null,
            isSaveAsDraft: isDraft
        };
        this.apiService.saveTrainingDetails(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status === 200) {
                this.license.id = response.data[0].id;
                this.toastr.success("License details saved successfully!", 'Success');
                response.data.forEach(element => {
                    this.configurations.entityId = element.id;
                    this.configurations.familyId = this.familyId ? this.familyId : null;
                    this.configurations = Object.assign({}, this.configurations);
                });
                this.configurations.useCaseId = this.beneficiaryId;
                this.getLicense();
                this.hasID = true;
                this.isLinear = false;
                licForm.reset(licForm.value);
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    getUpolodedFiles(id) {
        if (this.beneficiaryId && this.categoryName) {
            this.apiService.genericGetUploadDocument(this.configurations.useCase, this.configurations.useCaseId, this.categoryName, this.configurations.entityId, this.configurations.useEntityId, this.configurations.familyId)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                if (response['status'] === 200) {
                    if (response['data'] && response['data'].length > 0) {
                        response['data'].forEach(val => {
                            if (val.entityId == id) {
                                this.listUploadedFiles.push(val);
                                this.configurations.listUploadedFiles.push(val);
                                this.configurations = Object.assign({}, this.configurations);
                            }
                        });
                    }
                }
                else {
                    this.listUploadedFiles = [];
                    this.configurations.listUploadedFiles = [];
                    this.configurations = Object.assign({}, this.configurations);
                }
            });
        }
    }
    resetForm(licForm) {
        licForm.resetForm();
        this.infiniteDtFlag = false;
        this.license = {
            id: 0,
            name: '',
            subjects: '',
            institution: '',
            startDate: '',
            endDate: ''
        };
        this.listUploadedFiles = [];
        this.configurations.listUploadedFiles = [];
        this.configurations.entityId = 0;
        this.configurations.familyId = this.familyId ? this.familyId : null;
        this.configurations = Object.assign({}, this.configurations);
        this.listSubjects = new MatTableDataSource();
        this.hasID = false;
        this.isLinear = true;
    }
    redirectToDocs() {
        this.selectedIndex = 1;
    }
    handleTabChange(tab) {
        this.selectedIndex = tab.index;
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        // Add subject
        if ((value || '').trim()) {
            this.listAddedSubjects.push(value.trim());
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    pasteChips(event) {
        event.preventDefault(); // Prevents the default action
        event.clipboardData
            .getData('Text') // Gets the text pasted
            .split(/,/) // Splits it when a SEMICOLON or COMMA or NEWLINE
            .forEach(value => {
            if (value.trim()) {
                this.listAddedSubjects.push(value.trim()); // Push if valid
            }
        });
    }
    remove(fruit) {
        const index = this.listAddedSubjects.indexOf(fruit);
        if (index >= 0) {
            this.listAddedSubjects.splice(index, 1);
        }
    }
    addSubjects() {
        if (!this.license.id) {
            this.toastr.info('Please add the licence details first, then proceed to topics');
            return;
        }
        const payload = {
            id: this.license.id || 0,
            name: this.license.name,
            subjects: '',
            institution: this.license.institution,
            startDate: this.license.startDate ? moment(this.license.startDate).format('YYYY-MM-DD') : null,
            endDate: this.infiniteDtFlag ? null : (this.license.endDate ? moment(this.license.endDate).format('YYYY-MM-DD') : null),
        };
        const subs = [];
        if (this.listSubjects) {
            this.listSubjects.data.forEach((item) => {
                subs.push(item.subject);
            });
        }
        payload.subjects = subs.concat(this.listAddedSubjects).join();
        this.apiService.saveTrainingDetails(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status === 200) {
                this.toastr.success(response.message, 'Success');
                const obj = [];
                if (response.data[0]['subjects']) {
                    response.data[0]['subjects'].split(',').forEach((item) => {
                        obj.push({ 'subject': item });
                    });
                }
                this.listSubjects = new MatTableDataSource(obj);
                response.data.forEach(element => {
                    this.configurations.entityId = element.id;
                    this.configurations = Object.assign({}, this.configurations);
                });
                this.configurations.useCaseId = this.beneficiaryId;
                this.listAddedSubjects = [];
                this.getLicense();
                this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    deleteSubject(index) {
        this.listSubjects.data.splice(index, 1);
        this.addSubjects(); // Resolved for IM-5066
    }
    fileUploadSuccess() {
        // this.getLicense();
    }
    closeForm(f) {
        this.resetForm(f);
        this.toggleExpansion();
    }
    toggleListView(val) {
        if (!val) {
            this.isTimeLineView = true;
            this.isListView = false;
        }
        else {
            this.isTimeLineView = false;
            this.isListView = true;
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    dialogueInitializer(event, title, message) {
        const cordinates = event;
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '400px',
            data: {
                update: { title, message },
                buttons: ['Cancel', 'Delete']
            }
        });
        return dialogRef;
    }
    ngOnChanges(changes) {
        if (changes.editLicenceData.currentValue) {
            this.inputData = changes.editLicenceData.currentValue;
            this.getLicense();
        }
    }
    ngAfterViewInit() {
        if (this.modeVal) {
            this.showLifeStoryTimeLineSection = true;
            this.toggleListView(true);
        }
    }
    ngOnDestroy() {
        if (this.formChangesSubscriptions) {
            this.formChangesSubscriptions.forEach(item => { item.unsubscribe(); });
        }
        this.destroy$.next();
        this.destroy$.complete();
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    saveAsDraft(event) {
        this.saveLicenseTrianing(this.licForm, event);
    }
}
EditLicenseDetailsComponent.ɵfac = function EditLicenseDetailsComponent_Factory(t) { return new (t || EditLicenseDetailsComponent)(i0.ɵɵdirectiveInject(EditLicenseDetailsService), i0.ɵɵdirectiveInject(i2$1.ToastrService), i0.ɵɵdirectiveInject(i1$1.MatDialog), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i5.ActivatedRoute)); };
EditLicenseDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EditLicenseDetailsComponent, selectors: [["edit-license-details"]], viewQuery: function EditLicenseDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatPaginator, 3);
        i0.ɵɵviewQuery(MatSort, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { editLicenceData: "editLicenceData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "licenseContainer", 4, "ngIf"], [1, "licenseContainer"], [1, "mt-4", "btn-group", "row"], [1, "col-7"], ["class", "col viewType", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "add-placeholder", 4, "ngIf"], [4, "ngIf"], [1, "col", "viewType"], [1, "childBtn", "firstBtn", 3, "click"], ["matTooltip", "Change to timeline view", 1, "btn-icn"], [1, "childBtn", "lastBtn", 3, "click"], ["matTooltip", "Change to list view", 1, "btn-icn"], [1, "row"], [1, "add-placeholder"], ["mat-fab", "", "color", "primary", "class", "btn", 3, "click", 4, "ngIf"], ["mat-fab", "", "color", "primary", 1, "btn", 3, "click"], ["matTooltip", "Add License / Certificate"], [1, "spacing", "im-card-no-border-table"], [1, "p-3"], ["multiTemplateDataRows", "", "mat-table", "", 1, "im-card-no-border-table", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], [1, "example-element-description"], ["matColumnDef", "expandedDetail"], ["class", "w40", "mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], ["class", "btn btn-primary mb-2", "type", "button", 3, "click", 4, "ngIf"], ["hideToggle", "", 3, "expanded"], ["labelPosition", "bottom", 1, "pb-mat-stepper-custom-horizontal", 3, "linear"], ["stepper", ""], [3, "completed"], ["matStepLabel", ""], [3, "ngSubmit"], ["licForm", "ngForm"], [1, "formBox", 3, "ngClass"], [1, "form-group", "col-md-12", "mt-2"], [1, "label-cls"], ["type", "text", "name", "name", "placeholder", "Enter", 1, "im-input", 3, "ngModel", "ngModelChange"], ["name", "ngModel"], [1, "form-group", "col-md-12"], ["type", "text", "name", "institution", "placeholder", "Enter", 1, "im-input", 3, "ngModel", "ngModelChange"], ["institution", "ngModel"], ["name", "infineDtFlag", 1, "example-margin", 3, "ngModel", "ngModelChange"], [1, "form-group", "col-md-6"], ["appearance", "outline", 1, "mt-0", "date-field"], ["name", "startDt", "matInput", "", 3, "ngModel", "max", "matDatepicker", "ngModelChange", "click"], ["startDt", "ngModel"], ["matSuffix", "", 3, "for"], ["startDate", ""], ["class", "invalid-message", 4, "ngIf"], ["class", "form-group col-md-6", 4, "ngIf"], [1, "row", "paddingTop10", "dasheedTopBorder"], ["type", "submit", 1, "btn", "btn-success", 3, "disabled"], [1, "d-flex", "flex-row-reverse"], [1, "p-2"], ["type", "button", "matStepperNext", "", 1, "btn", "btn-primary", 3, "disabled"], ["class", "p-2", 4, "ngIf"], [1, "p-2", "f10", "mTop10"], [1, "row", "formBox", 3, "ngClass"], [1, "col-md-12"], [1, "row", "paddingTop10"], [1, "col-md-12", "required"], [1, "col-md-10"], ["appearance", "outline", 1, "example-chip-list", "chips-contianer"], ["aria-label", "Topic selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["placeholder", "New subject...", "name", "topic", 3, "matChipInputFor", "matChipInputSeparatorKeyCodes", "ngModel", "paste", "ngModelChange", "input", "matChipInputTokenEnd"], [1, "hint-text"], [1, "col-md-2"], ["type", "button", 1, "btn", "btn-success", 3, "disabled", "click"], ["mat-table", "", "matSort", "", 1, "im-card-no-border-table", 3, "dataSource"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], [1, "w-100"], [1, "col-md-6"], ["type", "button", "matStepperPrevious", "", 1, "back-button"], [1, "col-md-6", "text-right"], ["type", "button", "class", "back-button mr-3", 3, "click", 4, "ngIf"], ["type", "button", "matStepperNext", "", 1, "btn", "btn-primary", "pull-right"], [1, "col-md-12", "mt-2"], [1, "w-100", 3, "primaryData", "configurations", "fileUploadSuccess"], ["type", "button", 1, "btn", "btn-primary", "pull-right", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "mb-2", 3, "click"], [1, "invalid-message"], ["name", "endDt", "matInput", "", 3, "ngModel", "min", "matDatepicker", "ngModelChange", "click"], ["endDt", "ngModel"], ["endDate", ""], ["type", "button", 1, "back-button", 3, "click"], [3, "selectable", "removable", "removed"], ["matTooltip", "Remove this item", "matChipRemove", "", 4, "ngIf"], ["matTooltip", "Remove this item", "matChipRemove", ""], [3, "matColumnDef"], ["mat-header-cell", "", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-cell", "", "mat-sort-header", ""], ["mat-cell", ""], ["class", "column.customClass", 4, "ngIf"], [1, "column.customClass"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], ["mat-header-row", ""], ["mat-row", ""], ["type", "button", 1, "back-button", "mr-3", 3, "click"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-header-cell", ""], ["class", "row", "class", "toggle-col", 4, "ngIf"], [1, "toggle-col"], ["matTooltip", "View more"], ["class", "mr-1 icn", "matTooltip", "Edit", "class", "im-table-verticle-icon", 3, "click", 4, "ngIf"], ["class", "mr-1 icn", "matTooltip", "Delete", 3, "click", 4, "ngIf"], ["matTooltip", "Edit", 1, "im-table-verticle-icon", 3, "click"], ["mat-cell", "", 1, "w40"], [1, "example-element-detail"], ["class", "w100 example-element-description py-1", 4, "ngIf"], [1, "w100", "example-element-description", "py-1"], [1, "table", "table-striped"], ["class", "border border-dark", 4, "ngFor", "ngForOf"], [1, "border", "border-dark"], [1, "w40"], [1, "circleIndex", "rounded-circle"], ["nowrap", ""], [1, "im-card-no-border-table"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], [4, "ngFor", "ngForOf"], [3, "fileName", "Path"], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"]], template: function EditLicenseDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, EditLicenseDetailsComponent_div_0_Template, 7, 4, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showLifeStoryTimeLineSection);
    } }, directives: [i6.NgIf, i7.MatIcon, i8.MatTooltip, i9.MatTable, i6.NgForOf, i9.MatColumnDef, i9.MatCellDef, i9.MatHeaderRowDef, i9.MatRowDef, i10.MatAccordion, i10.MatExpansionPanel, i11.MatCard, i12.MatHorizontalStepper, i12.MatStep, i12.MatStepLabel, i13.ɵangular_packages_forms_forms_ba, i13.NgControlStatusGroup, i13.NgForm, i6.NgClass, i13.DefaultValueAccessor, i13.NgControlStatus, i13.NgModel, i14.MatCheckbox, i15.MatFormField, i16.MatInput, i17.MatDatepickerInput, i17.MatDatepickerToggle, i15.MatSuffix, i17.MatDatepicker, i12.MatStepperNext, i18.MatChipList, i18.MatChipInput, i15.MatHint, i12.MatStepperPrevious, i19.FileUploadDeafultLibraryComponent, i18.MatChip, i18.MatChipRemove, i9.MatHeaderCellDef, i9.MatHeaderCell, i9.MatCell, i9.MatHeaderRow, i9.MatRow, i20.FileDownloadLibraryComponent], styles: [".licenseContainer .mat-form-field{font-size:14px;width:100%}.licenseContainer .icn{cursor:pointer}.licenseContainer .spacing{margin:10px 0}.licenseContainer .f10{font-size:12px;color:#afaaaa}.licenseContainer .dasheedTopBorder{border-top:1px dashed grey}.licenseContainer .paddingTop10{padding-top:10px}.licenseContainer .mTop10{margin-top:10px!important}.licenseContainer .formBox{margin-top:10px!important;border-top:1px solid grey}.licenseContainer .w100{width:100%!important}.licenseContainer table{width:100%}.licenseContainer tr.example-detail-row{height:0}.licenseContainer tr.example-element-row:not(.example-expanded-row):hover{background:#f5f5f5}.licenseContainer tr.example-element-row:not(.example-expanded-row):active{background:#efefef}.licenseContainer .example-element-row td{border-bottom-width:0}.licenseContainer .example-element-detail{overflow:hidden}.licenseContainer .example-element-diagram{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.licenseContainer .example-element-symbol{font-weight:700;font-size:40px;line-height:normal}.licenseContainer .example-element-description{padding:16px}.licenseContainer .example-element-description-attribution{opacity:.5}.licenseContainer .topics-list-item{line-height:40px;width:80%;border:1px solid #d3d3d3;padding-left:25px}.licenseContainer .circleIndex{width:20px;height:20px;background-color:#8ecdd6;text-align:center}.licenseContainer .w40{width:40px!important}.licenseContainer .mLeft{margin-left:2rem}"], encapsulation: 2, data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditLicenseDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'edit-license-details',
                templateUrl: './edit-license-details.component.html',
                styleUrls: ['./edit-license-details.component.scss'],
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ],
            }]
    }], function () { return [{ type: EditLicenseDetailsService }, { type: i2$1.ToastrService }, { type: i1$1.MatDialog }, { type: i2.Store }, { type: i5.ActivatedRoute }]; }, { editLicenceData: [{
            type: Input
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }] }); })();

class EditLicenseDetailsModule {
}
EditLicenseDetailsModule.ɵfac = function EditLicenseDetailsModule_Factory(t) { return new (t || EditLicenseDetailsModule)(); };
EditLicenseDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: EditLicenseDetailsModule });
EditLicenseDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            NotificationComponentLibraryModule,
            SendBackComponentLibraryModule,
            DeleteDialogLibraryModule,
            FileUploadLibraryModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule,
            MatRadioModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            MatSidenavModule,
            MatListModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatCheckboxModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatSelectModule,
            CommonModule,
            ReactiveFormsModule,
            MatIconModule,
            MatTabsModule,
            MatSlideToggleModule,
            MatPaginatorModule,
            MatTableModule,
            FormsModule,
            NgbModule,
            MatTooltipModule,
            MatChipsModule,
            SaveAsDraftModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EditLicenseDetailsModule, { declarations: [EditLicenseDetailsComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        NotificationComponentLibraryModule,
        SendBackComponentLibraryModule,
        DeleteDialogLibraryModule,
        FileUploadLibraryModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule,
        MatRadioModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        MatSidenavModule,
        MatListModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatSelectModule,
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatTableModule,
        FormsModule,
        NgbModule,
        MatTooltipModule,
        MatChipsModule,
        SaveAsDraftModule], exports: [EditLicenseDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditLicenseDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [EditLicenseDetailsComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    NotificationComponentLibraryModule,
                    SendBackComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    FileUploadLibraryModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule,
                    MatRadioModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    MatSidenavModule,
                    MatListModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatSelectModule,
                    CommonModule,
                    ReactiveFormsModule,
                    MatIconModule,
                    MatTabsModule,
                    MatSlideToggleModule,
                    MatPaginatorModule,
                    MatTableModule,
                    FormsModule,
                    NgbModule,
                    MatTooltipModule,
                    MatChipsModule,
                    SaveAsDraftModule,
                ],
                exports: [EditLicenseDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of edit-license-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EditLicenseDetailsComponent, EditLicenseDetailsModule, EditLicenseDetailsService };
//# sourceMappingURL=edit-license-details.js.map
